module.exports = __webpack_public_path__ + "img/flag-DE.2f75a89c.svg";